export default __webpack_public_path__ + "static/media/Q18_3_resized.9eaebd6d.jpg";